import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where
} from 'firebase/firestore';
import { db } from './firebaseConfig';

const USERS_COLLECTION = 'users';

// Get all users from Firebase
export const getAllUsers = async () => {
  try {
    const usersCollection = collection(db, USERS_COLLECTION);
    const snapshot = await getDocs(usersCollection);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// Add a new user to Firebase
export const addUser = async (userData) => {
  try {
    const docRef = await addDoc(collection(db, USERS_COLLECTION), {
      ...userData,
      createdAt: new Date().toISOString()
    });
    return { id: docRef.id, ...userData };
  } catch (error) {
    console.error('Error adding user:', error);
    throw error;
  }
};

// Update a user in Firebase
export const updateUser = async (userId, userData) => {
  try {
    const userDoc = doc(db, USERS_COLLECTION, userId);
    await updateDoc(userDoc, userData);
    return { id: userId, ...userData };
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

// Delete a user from Firebase
export const deleteUser = async (userId) => {
  try {
    const userDoc = doc(db, USERS_COLLECTION, userId);
    await deleteDoc(userDoc);
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

// Find user by credentials (for login)
export const findUserByCredentials = async (username, password) => {
  try {
    const usersCollection = collection(db, USERS_COLLECTION);
    const q = query(
      usersCollection,
      where('username', '==', username),
      where('password', '==', password),
      where('active', '==', true)
    );
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      const doc = snapshot.docs[0];
      return { id: doc.id, ...doc.data() };
    }
    return null;
  } catch (error) {
    console.error('Error finding user:', error);
    throw error;
  }
};

// Check if email exists (for validation)
export const emailExists = async (email, excludeUserId = null) => {
  try {
    const usersCollection = collection(db, USERS_COLLECTION);
    const q = query(usersCollection, where('email', '==', email));
    const snapshot = await getDocs(q);
    if (excludeUserId) {
      return snapshot.docs.some(doc => doc.id !== excludeUserId);
    }
    return !snapshot.empty;
  } catch (error) {
    console.error('Error checking email:', error);
    throw error;
  }
};

// Check if username exists (for validation)
export const usernameExists = async (username, excludeUserId = null) => {
  try {
    const usersCollection = collection(db, USERS_COLLECTION);
    const q = query(usersCollection, where('username', '==', username));
    const snapshot = await getDocs(q);
    if (excludeUserId) {
      return snapshot.docs.some(doc => doc.id !== excludeUserId);
    }
    return !snapshot.empty;
  } catch (error) {
    console.error('Error checking username:', error);
    throw error;
  }
};
